module.exports = __webpack_public_path__ + "img/android-step1.8341e8c8.png";